import ReactDefaultProps from 'views/main/react/ReactDefaultProps';
import { fetchGdprFeature, resetGdprFeatureFetchState } from '../../../../reducers/gdpr/gdprFeature';

/**
 * In src/utils/gdpr/GdprLimitedFeatureAlert.jsx use gdpr feature to check whether should show alert
 * if user needs to confirm privacy, after confirmed, since this operation will update gdpr feature
 * should refresh gdpr feature to determine whether to show alert or not
 * this object use ReactDefaulProps.store (that is shared through all ReactComponentView) to dispatch action
 * which triggers re-fetch gdpr feature
 * */
const GdprFeatureUpdateInstance = {
    reFetchGdprFeature: function(key) {
        if (!ReactDefaultProps.store || typeof ReactDefaultProps.store.dispatch !== 'function') {
            return;
        }
        ReactDefaultProps.store.dispatch(fetchGdprFeature(key));
    },
    resetGdprFeatureFetchState: function() {
        if (!ReactDefaultProps.store || typeof ReactDefaultProps.store.dispatch !== 'function') {
            return;
        }
        ReactDefaultProps.store.dispatch(resetGdprFeatureFetchState());
    }
};

export default GdprFeatureUpdateInstance;
